import React from "react";

import logoBig from "../layout/assets/logo_big.png";
import logoSmall from "../layout/assets/logo_small.png";

import "./styles/components/Logo.css";

const Logo = props => {
  return (
    <div className={props.spin ? "logo-container spin-logo" : "logo-container"}>
      <div className="image-container">
        <img
          className="loading-logo"
          srcSet={`${logoSmall} 75w, ${logoBig} 400w`}
          sizes="(max-width: 900px) 8vw, (max-width: 600px) 12vw, (max-width: 400) 20vw"
          alt=""
          src={logoSmall}
        />
      </div>
      <div className="text-container">{props.children}</div>
    </div>
  );
};

export default Logo;



// WEBPACK FOOTER //
// ./src/components/layout/Logo.js